import { useLocation } from "@gatsbyjs/reach-router"

export const useCheckPreviewMode = () => {
  const location = useLocation()
  const queryParams =  new URLSearchParams(location.search)
  return queryParams.get('preview') === 'true'
}